const styles = {
  ptBox: {
    pt: 1,
    pb: 2,
  }
};

export default styles;